// extracted by mini-css-extract-plugin
export var select = "_pp-0";